const AuditTrail = {
    view: (id:string) => `auditTrail/${id}`,
  
  }
  export default AuditTrail
  